import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, TablePagination } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import { Item } from '../../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
import {
  bookingSummaryColumn,
  excelHeader1,
  lrDetailPdfFooter,
  paymentWiseDrawCell,
  paymentWiseDrawCellSummary,
  pdfHeaderColumn,
} from '../BookingConstants'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { useSelector } from 'react-redux'
import { RenderTable } from '../../analysisReport/summmaryTable'
import { RenderTableExcel } from '../../analysisReport/summaryTableExcel'
import { makeTable } from '../../analysisReport/pdfAutotable'
var totalPagesExp = '{total_pages_count_string}'
const FranchiseeToOwnSummary = ({
  loginData,
  tableData,
  fromDate,
  toDate,
  sourceCity,
  sourceBranch,
  sourceBranchUser,
  destinationCity,
  destinationBranch,
  paymentType,
  transactionType,
  selReportView,
  status,
  disableExcel,
  headers,
  UseToPayAsCOD
}) => {
  const companySettings = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySettings?.DefaultCurrencyID;
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  function pdfLogoDraw(data,doc) {
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text('Cargo System | Franchise To Own Booking Report', 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    lrDetailPdfFooter(data, loginData, totalPagesExp)
  }
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const pdfColumns = headers.map(col => ({header: col.exportHead,dataKey: col.field,xlCol: col.xlCol}));
    const HeaderColumns = pdfHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        sourceCity: sourceCity?.SourceCityName,
        sourceBranch: sourceBranch?.SourceBranchName,
        sourceBranchUser: sourceBranchUser,
        destCity: destinationCity?.DestCityName,
        destBranch: destinationBranch?.DestBranchName,
        paymentType: paymentType?.name,
        trnsType: transactionType?.TransType,
        reportView: selReportView?.ReportView,
        status: status?.LrStatus,
        dataType: 'entry'
      },
    ]

    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

    doc.setProperties({
      title: `Franchise To Own Reports.pdf`,
      subject: 'Franchise To Own  Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    makeTable(doc, autoTable, HeaderColumns, HeaderData, 1.5, '', loginData, "everyPage", () => { }, 200,false)
    makeTable(doc, autoTable, pdfColumns, tableData, 1.2, '', loginData, "never", pdfLogoDraw)
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Franchisee To Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('ownBooingDetailed').data = doc.output('datauristring', ' Franchise To Own Booking Report.pdf')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('ownBooingDetailed').data = doc.output('datauristring', ' Franchise To Own Booking Report.pdf')
      }, 2000)
    }
  }
  const SecontInsideRowContent = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          {item.isTotal ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
              >
                {item.srNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
              >
                {item.PayType}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.LRCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.ItemUnits}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.CartageAmount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.HamaliCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.Valuation}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.OtherCharges}
              </TableCell>
              {loginCountryId!==2&&
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.BookingGST}
              </TableCell>
              }
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.Amount}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.RefundAmt}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
              >
                {item.PayType}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.LRCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.ItemUnits}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.CartageAmount}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.HamaliCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.Valuation}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.OtherCharges}
              </TableCell>
              {loginCountryId!==2&&
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.BookingGST}
              </TableCell>
              }
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.Amount}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.RefundAmt}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  const SecontInsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          {item.isTotal ? (
            <>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'left' }}>
                {item.srNo}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'left' }}>
                {item.PayType}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.LRCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.ItemUnits}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.Freight}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.CartageAmount}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.HamaliCharges}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.Valuation}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.OtherCharges}
              </TableCell>
              {loginCountryId!==2&&
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.BookingGST}
              </TableCell>
              }
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.Amount}
              </TableCell>

              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.RefundAmt}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.SN}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.PayType}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.LRCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.ItemUnits}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.Freight}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.CartageAmount}
              </TableCell>

              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '700', textAlign: 'right' }}>
                {item.HamaliCharges}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.Valuation}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.OtherCharges}
              </TableCell>
              {loginCountryId!==2&&
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.BookingGST}
              </TableCell>
              }
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.Amount}
              </TableCell>

              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.RefundAmt}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px' }}>
        <Item className="userReport" style={{ paddingRight: '0px', paddingBottom: '0px' }}>
          <Item className="userReport-heading">Report For: Franchise To Own Booking</Item>
          <Item className="userReport-buttons">
            {showTable ? (
              <>
                {disableExcel ? (
                  <Box>
                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>
                      Export to Excel
                    </Button>
                  </Box>
                ) : (
                  <Box>
                    <ReactHtmlTableToExcel
                      id="test-table-xls-button"
                      className="userWisereporttemExcelBtn"
                      table="table-to-xls1"
                      filename={`Franchise To Own Booking ${currentDateTime}`}
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                  </Box>
                )}
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" onClick={() => printClick(true)}>
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" onClick={() => printClick(false)}>
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" onClick={() => setShowTable(true)}>
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {showTable ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 430, paddingTop: '7px', marginBottom: '16px' }} className="changeScrollColor">
            <TableContainer style={{ borderRadius: '6px', border: 'none',boxShadow: 'none' }}>
              <Table
                id="table-to-xls1"
                className="table1 table-Report"
                size="small"
                aria-label="a dense table"
                style={{ display: 'none', fontWeight: 'bold' }}
              >
                <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                  <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={6}>
                      Report For: Booking Report - Franchise To Own
                    </TableCell>
                    <TableCell className="reportTD" colSpan={7}>
                      Company Name : {loginData.strCompanyName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={13}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeader1?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{sourceCity?.SourceCityName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{sourceBranch?.SourceBranchName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{sourceBranchUser}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{destinationCity?.DestCityName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{destinationBranch?.DestBranchName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{paymentType?.name}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{transactionType?.TransType}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{selReportView?.ReportView} </span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{status?.LrStatus} </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={13}></TableCell>
                  </TableRow>
                </TableHead>
                 <RenderTableExcel showHeader={false} header={headers} data={tableData} key1="24r3w" key2="dgro" key3="foo43w"/>
              </Table>
              <RenderTable showHeader={false} header={headers} data={tableData} key1="ifi3k3" key2="3jew93" key3="d0323"/>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="ownBooingDetailed"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default FranchiseeToOwnSummary
